import React, { useState, useEffect, useContext } from "react";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, Form, InputGroup, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
import { Context } from "../../../../../utils/context";
import { Cities, Pincodes } from "../../../../../utils/apis/master/Master";
import { postData, getData } from "../../../../../utils/api";
import Cookies from "js-cookie";
import DatePicker from "react-datepicker";

const Step_One_New = ({ prevStep, nextStep }) => {
  const { IMG_URL, Select2Data } = useContext(Context);

  const [cityOptions, setCityOptions] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [loadingPincodes, setLoadingPincodes] = useState(false);
  const [user_id, setUserId] = useState(Cookies.get("seller_user_id") || "");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const imageFile1 = watch("logo");
  const imageFile2 = watch("license_image");

  // Load Cities on mount
  const loadCities = async () => {
    const res = await Cities();
    if (res?.success) {
      const data = await Select2Data(res.data, "city_id", false);
      setCityOptions(data);
    }
  };

  // Load Pincodes when city changes
  const handleCityChange = async (selectedCity) => {
    setValue("city_id", selectedCity);
    setValue("pincode_id", null); // reset pincode
    // setPincodeOptions([]);

    if (selectedCity?.value) {
      // setLoadingPincodes(true);
      const res = await Pincodes(selectedCity.value);
      if (res?.success) {
        const data = await Select2Data(res.data, "pincode_id");
        setPincodeOptions(data);
      }
      // setLoadingPincodes(false);
    }
  };

  // Fetch existing draft data if user_id exists
  const fetchDraftData = async () => {
    if (!user_id) return;

    try {
      const res = await getData(`/seller/seller-detail/${user_id}`);
      if (res?.success) {
        const seller = res.data;
        const details = seller.seller_detail || {};

        reset({
          first_name: seller.first_name || "",
          contact_no: seller.contact_no || "",
          email: seller.email || "",
          whatsapp_number: details.whatsapp_number || "",
          city_id: null, // will be set below
          pincode_id: null,
          area: details.area || "",
          shop_name: details.shop_name || "",
          certification_name: details.certification_name || "",
          // license: details.license || "",
          // license_expiry_date: details.license_expiry_date
          //   ? new Date(details.license_expiry_date)
          //   : null,
          registration_number: details.registration_number || "",
          // license_type: details.license_type || "",
          // license_name: details.license_name || "",
          // license_address: details.license_address || "",
          logo: details.logo || "",
          license_image: details.license_image || "",
        });

        // Preselect city & load its pincodes
        if (details.city_id) {
          const cityObj = cityOptions.find((c) => c.value == details.city_id);
          if (cityObj) {
            setValue("city_id", cityObj);
            // Load pincodes for this city
            setLoadingPincodes(true);
            const pinRes = await Pincodes(details.city_id);
            if (pinRes?.success) {
              const pinData = await Select2Data(
                pinRes.data,
                "pincode_id",
                false,
              );
              setPincodeOptions(pinData);

              const pinObj = pinData.find((p) => p.value == details.pincode_id);
              if (pinObj) setValue("pincode_id", pinObj);
            }
            setLoadingPincodes(false);
          }
        }
      }
    } catch (err) {
      console.log("Error loading draft:", err);
    }
  };

  useEffect(() => {
    loadCities();
  }, []);

  useEffect(() => {
    if (user_id && cityOptions.length > 0) {
      fetchDraftData();
    }
  }, [user_id, cityOptions]);

  const onSubmit = async (data) => {
    const formData = new FormData();

    // Append all fields
    formData.append("first_name", data.first_name);
    formData.append("contact_no", data.contact_no);
    formData.append("email", data.email);
    formData.append("city_id", data.city_id?.value || "");
    formData.append("pincode_id", data.pincode_id?.value || "");
    formData.append("area", data.area);
    formData.append("shop_name", data.shop_name);
    formData.append("whatsapp_number", data.whatsapp_number || "");
    formData.append("certification_name", data.certification_name || "");
    // formData.append("license", data.license);
    // formData.append(
    //   "license_expiry_date",
    //   data.license_expiry_date
    //     ? data.license_expiry_date.toISOString().split("T")[0]
    //     : ""
    // );
    formData.append("registration_number", data.registration_number || "");
    // formData.append("license_type", data.license_type);
    // formData.append("license_name", data.license_name);
    // formData.append("license_address", data.license_address);

    if (data.logo && data.logo[0]) {
      formData.append("logo", data.logo[0]);
    }
    if (data.license_image && data.license_image[0]) {
      formData.append("license_image", data.license_image[0]);
    }

    // If editing existing draft
    if (user_id) {
      formData.append("user_id", user_id);
    }

    try {
      const res = await postData("/seller/add", formData);

      if (res?.success) {
        // Save user_id for next steps
        const id = res.data?.user?.id || res.data?.user_id;
        if (id) {
          Cookies.set("seller_user_id", id, { expires: 30 });
          setUserId(id);
        }
        alert("Step 1 saved successfully!");
        nextStep();
      } else {
        setError("contact_no", {
          type: "manual",
          message: res?.message,
        });

        // alert(res?.message || "Failed to save");
      }
    } catch (error) {
      console.error(error);
      // alert("Error saving data");
    }
  };

  return (
    <>
      <div className="personal-details-form ">
        <div className="details-form-holder">
          <div className="form-container">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                <div className="row">
                  {/* Owner Name */}
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        Name of Owner <span className="req_star">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Name of Owner"
                        {...register("first_name", {
                          required: "First name is required",
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.first_name,
                        })}
                      />
                      {errors.first_name && (
                        <span className="text-danger">
                          {errors.first_name.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Contact Number */}
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required form-field">
                        Owner Contact Number <span className="req_star">*</span>
                      </Form.Label>
                      <div className="get-otp-text">
                        <Form.Control
                          type="text"
                          placeholder="Enter Owner Contact Number"
                          {...register("contact_no", {
                            required: "Contact number is required",
                            validate: {
                              isTenDigits: (v) =>
                                (v && v.length === 10) || "Must be 10 digits",
                              isNumeric: (v) =>
                                /^\d+$/.test(v) || "Only numbers allowed",
                            },
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.contact_no,
                            "is-valid":
                              !errors?.contact_no &&
                              getValues("contact_no")?.length === 10,
                          })}
                          onKeyDown={(e) => {
                            if (
                              !/[0-9]/.test(e.key) &&
                              !["Backspace", "Tab"].includes(e.key)
                            )
                              e.preventDefault();
                            if (
                              e.target.value.length >= 10 &&
                              !["Backspace", "Tab"].includes(e.key)
                            )
                              e.preventDefault();
                          }}
                        />
                        {errors.contact_no && (
                          <span className="text-danger">
                            {errors.contact_no.message}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        Owner Email ID <span className="req_star">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter Owner Email ID"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Invalid email address",
                          },
                        })}
                        className={classNames("", {
                          "is-invalid": errors?.email,
                        })}
                      />
                      {errors.email && (
                        <span className="text-danger">
                          {errors.email.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* WhatsApp Number */}
                  <div className="col-md-6">
                    <Form className="field-bottom">
                      <Form.Label className="required">
                        WhatsApp Number <span className="req_star">*</span>
                      </Form.Label>
                      <div className="get-otp-text">
                        <Form.Control
                          type="text"
                          placeholder="Enter WhatsApp Number"
                          {...register("whatsapp_number", {
                            required: "WhatsApp number is required",
                            validate: (v) =>
                              !v ||
                              (v.length === 10 && /^\d+$/.test(v)) ||
                              "Must be 10 digits",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.whatsapp_number,
                            "is-valid":
                              !errors?.whatsapp_number &&
                              getValues("whatsapp_number")?.length === 10,
                          })}
                          onKeyDown={(e) => {
                            if (
                              !/[0-9]/.test(e.key) &&
                              !["Backspace", "Tab"].includes(e.key)
                            )
                              e.preventDefault();
                            if (
                              e.target.value.length >= 10 &&
                              !["Backspace", "Tab"].includes(e.key)
                            )
                              e.preventDefault();
                          }}
                        />
                        {errors.whatsapp_number && (
                          <span className="text-danger">
                            {errors.whatsapp_number.message}
                          </span>
                        )}
                      </div>
                    </Form>
                  </div>

                  {/* City */}
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        City <span className="req_star">*</span>{" "}
                      </Form.Label>
                      <Controller
                        name="city_id"
                        control={control}
                        rules={{ required: "Please select a city" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={cityOptions}
                            placeholder="Select City"
                            onChange={handleCityChange}
                            isSearchable
                            isClearable
                          />
                        )}
                      />
                      {errors.city_id && (
                        <span className="text-danger">
                          {errors.city_id.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Pincode - Right next to City */}
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        Pincode <span className="req_star">*</span>{" "}
                      </Form.Label>
                      <Controller
                        name="pincode_id"
                        control={control}
                        rules={{ required: "Please select a pincode" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={pincodeOptions}
                            placeholder={"Select Pincode"}
                            // isDisabled={loadingPincodes}
                            isSearchable
                            isClearable
                          />
                        )}
                      />
                      {errors.pincode_id && (
                        <span className="text-danger">
                          {errors.pincode_id.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Area */}
                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Label className="required">
                        Area <span className="req_star">*</span>{" "}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Area"
                        {...register("area", { required: "Area is required" })}
                      />
                      {errors.area && (
                        <span className="text-danger">
                          {errors.area.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Shop Name */}
                  <div className="col-md-6">
                    <div className="form-field">
                      <Form.Label className="required">
                        Shop / Showroom Name <span className="req_star">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Shop/Showroom Name"
                        {...register("shop_name", {
                          required: "Shop name required",
                        })}
                      />
                      {errors.shop_name && (
                        <span className="text-danger">
                          {errors.shop_name.message}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Logo Upload */}
                  <div className="col-lg-6 col-md-9">
                    <div className="img_input_holder">
                      <div className="img_form_field mb-4">
                        <Form.Label className="required">
                          Logo <span className="req_star">*</span>{" "}
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          {...register("logo", {
                            validate: async (value) => {
                              if (!value || value.length === 0) {
                                return "Logo is required";
                              }

                              if (typeof value === "string") return true;

                              const file = value[0];
                              if (!file) {
                                return "Logo is required";
                              }
                            },
                          })}
                        />
                        {errors.logo && (
                          <span className="text-danger">
                            {errors.logo.message}
                          </span>
                        )}
                      </div>

                      <div className="img_container">
                        <Row className="justify-content-center">
                          <Form.Label>Image Preview</Form.Label>
                          {typeof getValues("logo") === "string" &&
                          getValues("logo") ? (
                            <img
                              src={IMG_URL + getValues("logo")}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          ) : (
                            imageFile1?.length > 0 && (
                              <img
                                src={URL.createObjectURL(imageFile1[0])}
                                alt="Preview"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  marginTop: "10px",
                                  aspectRatio: "1 / 1",
                                  objectFit: "contain",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                }}
                              />
                            )
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-9">
                    <div className="img_input_holder">
                      <div className="img_form_field mb-4">
                        <Form.Label className="required">
                          License Image
                          {/* <span className="req_star">*</span> */}
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          {...register("license_image", {
                            validate: async (value) => {
                              if (!value || value.length === 0) {
                                // return " License Image is required";
                              }

                              if (typeof value === "string") return true;

                              const file = value[0];
                              // if (!file) {
                              //   return " License Image is required";
                              // }
                            },
                          })}
                        />
                        {errors.license_image && (
                          <span className="text-danger">
                            {errors.license_image.message}
                          </span>
                        )}
                      </div>

                      <div className="img_container">
                        <Row className="justify-content-center">
                          <Form.Label>Image Preview</Form.Label>
                          {typeof getValues("license_image") === "string" &&
                          getValues("license_image") ? (
                            <img
                              src={IMG_URL + getValues("license_image")}
                              alt="Preview"
                              style={{
                                width: "80px",
                                height: "80px",
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          ) : (
                            imageFile2?.length > 0 && (
                              <img
                                src={URL.createObjectURL(imageFile2[0])}
                                alt="Preview"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  marginTop: "10px",
                                  aspectRatio: "1 / 1",
                                  objectFit: "contain",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                }}
                              />
                            )
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="name">
                        <Form.Label className="required">
                          Name of Certification{" "}
                          {/* <span className="req_star">*</span> */}
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="certification_name"
                          placeholder="Enter Name of Certification"
                          className={classNames("", {
                            "is-invalid": errors?.certification_name,
                          })}
                          {...register("certification_name", {
                            // required: "Certification Name is required",
                          })}
                        />
                        {/* {errors.certification_name && (
                          <span className="text-danger">
                            {errors.certification_name.message}
                          </span>
                        )} */}
                      </Form.Group>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">License</Form.Label>

                        <Form.Control
                          type="text"
                          name="license"
                          placeholder="Enter License"
                          className={classNames("", {
                            "is-invalid": errors?.license,
                          })}
                          {...register("license", {
                            required: "license is required",
                          })}
                        />

                        {errors.license && (
                          <span className="text-danger">
                            {errors.license.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div> */}

                  {/* <div className="col-md-6">
                    <div className="form-field">
                      <Form.Group controlId="Last_Name">
                        <Form.Label className="required">
                          License Expiry Date
                        </Form.Label>

                        <Controller
                          control={control}
                          name="license_expiry_date"
                          rules={{
                            required: "License expiry date is required",
                          }}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              selected={field.value}
                              onChange={(date) => field.onChange(date)}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select License Expiry Date"
                              minDate={new Date()}
                              className={classNames("form-control", {
                                "is-invalid": errors?.license_expiry_date,
                              })}
                            />
                          )}
                        />

                        {errors.license_expiry_date && (
                          <span className="text-danger">
                            {errors.license_expiry_date.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div> */}

                  <div className="col-md-6">
                    <div className="field-bottom">
                      <Form.Group controlId="Last_Name">
                        <div className="d-flex justify-content-between">
                          <Form.Label className="required form-field">
                            Enter License Number{" "}
                            {/* <span className="req_star">*</span> */}
                          </Form.Label>
                          {/* <p className="mb-0 validate" onClick={handleFields}>Validate</p> */}
                        </div>

                        <div className="get-otp-text">
                          <Form.Control
                            type="text"
                            name="registration_number"
                            placeholder="Enter License Number"
                            className={classNames("", {
                              "is-invalid": errors?.registration_number,
                            })}
                            {...register("registration_number", {
                              // required: "Enter License Number",
                            })}
                          />

                          {errors.registration_number && (
                            <span className="text-danger">
                              {errors.registration_number.message}
                            </span>
                          )}
                        </div>
                      </Form.Group>
                    </div>
                  </div>

                  {/* {fieldclick && ( */}
                  <>
                    {/* <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            License Type
                          </Form.Label>

                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_type"
                              placeholder="License Type"
                              className={classNames("", {
                                "is-invalid": errors?.license_type,
                              })}
                              {...register("license_type", {
                                required: "License Type is required",
                              })}
                            />

                            {errors.license_type && (
                              <span className="text-danger">
                                {errors.license_type.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div> */}

                    {/* <div className="col-md-6">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            Name on License*
                          </Form.Label>
                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_name"
                              placeholder="Enter Name on License"
                              className={classNames("", {
                                "is-invalid": errors?.license_name,
                              })}
                              {...register("license_name", {
                                required: "license_name is required",
                              })}
                            />

                            {errors.license_name && (
                              <span className="text-danger">
                                {errors.license_name.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div> */}

                    {/* <div className="col-md-12">
                      <div className="field-bottom">
                        <Form.Group controlId="Last_Name">
                          <Form.Label className="required form-field">
                            Address in License
                          </Form.Label>
                          <div className="get-otp-text">
                            <Form.Control
                              type="text"
                              name="license_address"
                              placeholder="License Type"
                              className={classNames("", {
                                "is-invalid": errors?.license_address,
                              })}
                              {...register("license_address", {
                                required: "License Address is required",
                              })}
                            />

                            {errors.license_address && (
                              <span className="text-danger">
                                {errors.license_address.message}
                              </span>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </div> */}
                  </>

                  <div className="col-md-12">
                    <div className="text-start apply_now_btn">
                      <div className="registerContinueMain">
                        <Button className="tabs-btn" type="submit">
                          Next
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step_One_New;
